import type { Dispatch, SetStateAction } from 'react';
import type { User } from 'types/users';
import type { Order } from 'types/orders';

export type Note = {
  id: string;
  content: string;
  userId?: string;
  orderId?: string;
  atPickup?: boolean;
  atDropOff?: boolean;
  user?: User;
  order?: Order;
};

export type CustomersActionsProps = {
  selectedCustomers: Array<string>;
  setSelectedCustomers: Dispatch<SetStateAction<Array<string>>>;
};

export enum AdminPanelRoutesPaths {
  DASHBOARD = 'dashboard',
  RENTALS = 'rentals',
  CARS = 'cars',
  NEW_CAR = 'cars/new',
  EDIT_CAR = 'cars/edit/:id',
  NEW_DISCOUNT = 'discounts/new',
  CUSTOMERS = 'customers',
  DISCOUNTS = 'discounts',
  CONTENT = 'content',
  SETTINGS = 'settings',
  NEW_ACCOUNT = 'accounts/new',
  EDIT_ACCOUNT = 'accounts/edit/:id',
  ORDER_INFORMATION = 'rentals/orders/:id',
  CUSTOMER_INFORMATION = 'customers/:id',
  SUBSCRIPTIONS = 'subscriptions',
  SUBSCRIPTION_INFORMATION = 'subscriptions/:id',
}
